import Button from "../../Shared/Button";
import Input from "../../Shared/Input";
import TextArea from "../../Shared/TextArea";
import { useFormik } from "formik";
import { AddNewCourse, AddCourseDTO } from "../../../api/Courses/AddCourse";
import { useMutation, useQuery } from "@tanstack/react-query";
import * as Yup from "yup";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../../utils/consts";
import Spinner from "../../Shared/Spinner";
import { toast } from "react-toastify";
import { queryClient } from "../../../main";
import Upload from "../../Shared/Upload";
import { GetAllInstructors } from "../../../api/Instructor/GetAllInstructors";
import Selectbox from "../../Shared/SelectBox";
import { useEffect, useState } from "react";
import { GetAllCategories } from "../../../api/Categories/GetAllCategories";
import { useParams, useNavigate } from "react-router-dom";
import { GetCourseById } from "../../../api/Courses/GetCourseById";
import { EditCourse } from "../../../api/Courses/EditCourse";
import { Switch } from "@headlessui/react";
interface option {
  id?: string;
  name: string;
}

const validationSchema = Yup.object({
  name: Yup.string().required("Course name is required"),
  description: Yup.string().required("Course description is required"),
  img_url: Yup.string().required("Display Image is required"),
  num_hours: Yup.string().required("Number of hours is required"),
  borchure_url: Yup.string().optional(),
  actualPrice_egp: Yup.string().required("Price is required"),
  actualPrice_usd: Yup.string().required("Price is required"),
  preview_video: Yup.string().required("Preview Video is required"),
  InstructorId: Yup.string().required("Preview Video is required"),
  categoryId: Yup.string().required("Preview Video is required"),
});

const AddCourse = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [selected, setSelected] = useState<option | null>(null);
  const [categorySelected, setCategorySelected] = useState<option | null>(null);
  const { id } = useParams();
  const courseSlug = id || "";
  const [enabled, setEnabled] = useState(false);
  const { data: CourseByIdDTO, isLoading: isCourseLoading } = useQuery({
    queryFn: () => GetCourseById(courseSlug),
    queryKey: ["courses", courseSlug],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!id,
  });
  const navigate = useNavigate();
  const courses = CourseByIdDTO?.data;
  const courseId = courses?.id || "";
  useEffect(() => {
    if (courses) {
      const isTrending = courses.isTrending || false;
      setEnabled(isTrending);
      formik.setFieldValue("isTrending", isTrending, false);
    }
  }, [courses]);

  const { mutate, error, isPending } = useMutation({
    mutationFn: AddNewCourse,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["courses"] });
      toast.success("Course Added successfully");
      formik.resetForm();
      onSuccess && onSuccess();
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });
  const { mutate: editMutate, isPending: isEditPending } = useMutation({
    mutationFn: (data: AddCourseDTO) => EditCourse(data, courseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["courses"] });
      toast.success("Course Edited successfully");
      formik.setSubmitting(true);
      navigate("/dashboard/courses");
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });

  const { data: InstructorDTO } = useQuery({
    queryFn: GetAllInstructors,
    queryKey: ["instructors"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const { data: CategoriesDTO } = useQuery({
    queryFn: GetAllCategories,
    queryKey: ["categories"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const Categories =
    CategoriesDTO?.data?.map((category) => ({
      id: category.id,
      name: category.name,
    })) || [];

  const Instructor =
    InstructorDTO?.data?.map((instructor) => ({
      id: instructor.id,
      name: instructor.firstName + " " + instructor.lastName,
    })) || [];
  const formik = useFormik({
    initialValues: {
      name: courses?.name || "",
      description: courses?.description || "",
      part: courses?.part || "",
      borchure_url: courses?.borchure_url || "",
      img_url: courses?.img_url || "",
      num_hours: courses?.num_hours || "",
      actualPrice_egp: String(courses?.actualPrice_egp || ""),
      actualPrice_usd: String(courses?.actualPrice_usd || ""),
      preview_video: courses?.preview_video || "",
      InstructorId: courses?.InstructorId || "",
      categoryId: courses?.categoryId || "",
      isTrending: courses?.isTrending || false,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      const formattedValues: AddCourseDTO = {
        ...values,
        num_hours: String(values.num_hours),
        actualPrice_egp: String(values.actualPrice_egp),
        actualPrice_usd: String(values.actualPrice_usd),
        isTrending: enabled,
      };

      if (id) {
        editMutate(formattedValues);
      } else {
        mutate(formattedValues);
      }
    },
  });
  const handleSelectInstructor = (option: option | null) => {
    setSelected(option);
    if (option) {
      formik.setFieldValue("InstructorId", option.id);
    } else {
      formik.setFieldValue("InstructorId", "");
    }
  };
  const handleSelectCategory = (option: option | null) => {
    setCategorySelected(option);
    if (option) {
      formik.setFieldValue("categoryId", option.id);
    } else {
      formik.setFieldValue("categoryId", "");
    }
  };
  const handleTrendingToggle = (value: boolean) => {
    setEnabled(value);
    formik.setFieldValue("isTrending", value, false);
  };

  const handleimgUrlUpload = (url: string) => {
    formik.setFieldValue("img_url", url);
  };
  const handleVideoUrlUpload = (url: string) => {
    formik.setFieldValue("preview_video", url);
  };
  const handleBorchureUrlUpload = (url: string) => {
    formik.setFieldValue("borchure_url", url);
  };

  if (isCourseLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <form onSubmit={formik.handleSubmit} className="pt-5">
      <div className="flex justify-between mb-6">
        <h1 className="text-burntBlack font-bold text-[32px] mt-5">
          {id ? "Edit course" : "Upload new course"}
        </h1>
      </div>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15 min-h-[70vh] flex gap-16">
        <div className="w-full">
          <h1 className="mb-2.5 font-bold text-2xl">Course info</h1>
          <p className="text-lightGray font-medium">
            Add Class details to help students discover your class and better
            understand what they will learn. what they will need and expect
          </p>
          <div className="space-y-7 pt-8">
            <Input
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : ""
              }
              className="text-lg font-semibold"
              inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              title="Course Title"
              placeholder=""
              name="name"
              type="text"
            />
            <TextArea
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && formik.errors.description
                  ? formik.errors.description
                  : ""
              }
              name="description"
              title="Course Description"
              placeholder=""
              inputStyles="!bg-[#F5F6F8] !h-[224px] border-black/15"
            />
            <Input
              value={String(formik.values.part)}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.part && formik.errors.part
                  ? formik.errors.part
                  : ""
              }
              className="text-lg font-semibold"
              inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              title="Part"
              placeholder=""
              name="part"
              type="text"
            />
            <div className="flex gap-5 pt-7">
              <Input
                value={String(formik.values.actualPrice_egp)}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actualPrice_egp &&
                  formik.errors.actualPrice_egp
                    ? formik.errors.actualPrice_egp
                    : ""
                }
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                title="Price in EGP"
                placeholder=""
                name="actualPrice_egp"
                type="text"
              />
              <Input
                value={String(formik.values.actualPrice_usd)}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actualPrice_usd &&
                  formik.errors.actualPrice_usd
                    ? formik.errors.actualPrice_usd
                    : ""
                }
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                title="Price in USD"
                placeholder=""
                name="actualPrice_usd"
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="w-full">
          {/* <h1 className="mb-2.5 font-bold text-2xl">Course Media</h1>
          <p className="text-lightGray font-medium">Add course media to make it more catchy to visitors.</p> */}

          <div className="space-y-7 pt-8">
            <Upload folder="courses_images" onFileUploaded={handleimgUrlUpload}>
              <Input
                upload={true}
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                placeholder=""
                title="Course Image"
                name="img_url"
                type="text"
                value={formik.values.img_url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.img_url && formik.errors.img_url
                    ? formik.errors.img_url
                    : ""
                }
              />
            </Upload>
            <Upload
              folder="courses_promo"
              onFileUploaded={handleVideoUrlUpload}
              acceptedFiles={{
                "video/mp4": [],
                "video/webm": [],
                "video/ogg": [],
              }}
            >
              <Input
                upload={true}
                value={formik.values.preview_video}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.preview_video && formik.errors.preview_video
                    ? formik.errors.preview_video
                    : ""
                }
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                title="Course Promo Video"
                placeholder=""
                name="preview_video"
                type="text"
              />
            </Upload>
            <Upload
              folder="courses_borchure"
              onFileUploaded={handleBorchureUrlUpload}
              acceptedFiles={{ pdf: [] }}
            >
              <Input
                upload={true}
                value={formik.values.borchure_url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.borchure_url && formik.errors.borchure_url
                    ? formik.errors.borchure_url
                    : ""
                }
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                title="Course Borchure"
                placeholder=""
                name="borchure_url"
                type="text"
              />
            </Upload>

            <Input
              value={String(formik.values.num_hours)}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.num_hours && formik.errors.num_hours
                  ? formik.errors.num_hours
                  : ""
              }
              className="text-lg font-semibold"
              inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              title="Number of hours"
              placeholder=""
              name="num_hours"
              type="text"
            />
            <Selectbox
              title="Instructor"
              className="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              name="InstructorId"
              setSelected={handleSelectInstructor}
              selected={selected}
              selectOptions={Instructor}
            />
            <Selectbox
              title="Category"
              className="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              name="categoryId"
              setSelected={handleSelectCategory}
              selected={categorySelected}
              selectOptions={Categories}
            />
            <div className={`md:space-y-2 space-y-1.5 relative font-medium`}>
              <h1 className="text-burntBlack md:text-base text-sm">
                Is Trending
              </h1>
              <Switch
                checked={enabled}
                onChange={handleTrendingToggle}
                className={`${enabled ? "bg-secondary" : "bg-primary"}
          relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
              >
                <span
                  aria-hidden="true"
                  className={`${enabled ? "translate-x-9" : "translate-x-0"}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>
            </div>
            {error instanceof AxiosError && (
              <span className="text-red-500 font-bold text-lg">
                {error?.response?.data?.message || "An error occurred"}
              </span>
            )}
            <Button
              className="!h-14 w-full !text-lg font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
              variant="primary"
              type={ButtonTypes.SUBMIT}
              disabled={formik.isSubmitting || isPending || isEditPending}
            >
              Done {isPending || isEditPending ? <Spinner /> : ""}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AddCourse;
